import React, { useState } from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { OrgSelect } from "@/components/common/OrgSelect";
import { UsersManager } from "@/components/common/UsersManager";

export default function PlatformUsers() {
  const [orgId, setOrgId] = useState(null);
  return (
    <div data-testid="platform-users-page">
      <PageHeader title="Users" subtitle="Create users, assign them to facilities and grant roles. Users belong to one organisation."
        actions={<OrgSelect value={orgId} onChange={setOrgId} />} />
      {orgId ? <UsersManager orgId={orgId} canEdit /> : <div className="text-sm text-slate-400 bg-white border border-slate-200 rounded-md py-16 text-center">Select an organisation to manage its users.</div>}
    </div>
  );
}
